import { WORK_ORDER_STATUS } from '#/modules/momMgmt/workOrder/helper/workOrderStatus';

/** 工單異動單狀態：DRAFT → SUBMITTED → APPROVED | REJECTED。 */

export const WORK_ORDER_AMENDMENT_STATUS = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
};

export const WORK_ORDER_AMENDMENT_STATUS_LABELS = {
  DRAFT: '草稿',
  SUBMITTED: '已提交',
  APPROVED: '已核准',
  REJECTED: '已退回',
};

/** 寫死色票：深底淺字 */
export const WORK_ORDER_AMENDMENT_STATUS_CLASS = {
  DRAFT: 'border-transparent bg-slate-600 text-slate-50',
  SUBMITTED: 'border-transparent bg-sky-600 text-sky-50',
  APPROVED: 'border-transparent bg-emerald-600 text-emerald-50',
  REJECTED: 'border-transparent bg-rose-600 text-rose-50',
};

export function formatWorkOrderAmendmentStatusLabel(status) {
  if (status == null || status === '') {
    return '—';
  }
  return WORK_ORDER_AMENDMENT_STATUS_LABELS[status] ?? status;
}

export function isOpenWorkOrderAmendmentStatus(status) {
  return status === WORK_ORDER_AMENDMENT_STATUS.DRAFT
    || status === WORK_ORDER_AMENDMENT_STATUS.SUBMITTED;
}

export function hasOpenWorkOrderAmendment(amendments) {
  return (amendments ?? []).some((row) => isOpenWorkOrderAmendmentStatus(row?.status));
}

export function findOpenWorkOrderAmendment(amendments) {
  return (amendments ?? []).find((row) => isOpenWorkOrderAmendmentStatus(row?.status))
    ?? null;
}

export function canMutateWorkOrderAmendment(workOrderStatus) {
  return workOrderStatus === WORK_ORDER_STATUS.PROCESSING;
}

export function canEditWorkOrderAmendmentDraft(amendment, workOrderStatus) {
  return canMutateWorkOrderAmendment(workOrderStatus)
    && amendment?.status === WORK_ORDER_AMENDMENT_STATUS.DRAFT;
}

export function canSubmitWorkOrderAmendmentDraft(amendment, workOrderStatus) {
  return canEditWorkOrderAmendmentDraft(amendment, workOrderStatus);
}

export function canDeleteWorkOrderAmendmentDraft(amendment, workOrderStatus) {
  return canEditWorkOrderAmendmentDraft(amendment, workOrderStatus);
}

export function canApproveWorkOrderAmendment(amendment, workOrderStatus) {
  return canMutateWorkOrderAmendment(workOrderStatus)
    && amendment?.status === WORK_ORDER_AMENDMENT_STATUS.SUBMITTED;
}

export function canRejectWorkOrderAmendment(amendment, workOrderStatus) {
  return canApproveWorkOrderAmendment(amendment, workOrderStatus);
}

/** 已有工單來源出庫（已完成）則不可改替代料。 */
export function hasWorkOrderSourceOutbound(detail) {
  const hasCompletedIssue = (detail?.stockIssues ?? []).some(
    (row) => row?.status === 'COMPLETED',
  );
  if (hasCompletedIssue) {
    return true;
  }
  const requirements = detail?.mtrRequirements ?? detail?.materialRequirements ?? [];
  return requirements.some(
    (row) => Number(row?.issuedQty ?? 0) > 0,
  );
}

export function pickAmendmentUpdatedAt(amendment) {
  return amendment?.record?.updatedAt ?? amendment?.updatedAt ?? null;
}

/** 僅 PROCESSING 可建；同工單同時最多一張 DRAFT／SUBMITTED。 */
export function canCreateWorkOrderAmendment(detail) {
  if (detail?.status !== WORK_ORDER_STATUS.PROCESSING) {
    return false;
  }
  return !hasOpenWorkOrderAmendment(detail?.amendments);
}

/** amendment_no DESC（後端已排；前端再排一次）。不改動原陣列。 */
export function sortWorkOrderAmendmentsDesc(amendments) {
  return [...(amendments ?? [])].sort((left, right) => (
    String(right?.amendmentNo ?? '').localeCompare(
      String(left?.amendmentNo ?? ''),
      undefined,
      { numeric: true },
    )
  ));
}
